// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserPhones_wrapper__9wHvo","phones":"UserPhones_phones__YflKP","phone":"UserPhones_phone__AQVRO"};